import { render, staticRenderFns } from "./review-not-found.vue?vue&type=template&id=66f2c5f0"
import script from "./review-not-found.vue?vue&type=script&lang=ts"
export * from "./review-not-found.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports